import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { SignIn } from "../../Services/Auth/Auth"; // Ensure this service is properly defined
import { useNavigate, Link, useLocation } from "react-router-dom";
import { getCompanyApi } from "../../Services/Superadmin/Superadmin";
import { googleLogin } from "../../Services/Auth/Auth";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { getAllClient } from "../../Services/Superadmin/Superadmin";
import { getUserFromToken } from "../../Utils/TokenVerify";


let CountryCodes = [
  { code: "+1", country: "USA" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+86", country: "China" },
  { code: "+39", country: "Italy" },
  { code: "+7", country: "Russia" },
  // Add more country codes as needed
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+971", country: "UAE" },
  { code: "+27", country: "South Africa" },
  { code: "+34", country: "Spain" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+82", country: "South Korea" },
  { code: "+60", country: "Malaysia" },
  { code: "+65", country: "Singapore" },
  { code: "+31", country: "Netherlands" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+358", country: "Finland" },
  { code: "+353", country: "Ireland" },
  { code: "+64", country: "New Zealand" },
]

const Register = () => {

  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;


  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [logo, setLogo] = useState('');

  const [clientId, setClentId] = useState("")


  var ReferalCode = location.pathname.split('/');


  const refCode = ReferalCode[2]



  useEffect(() => {
    fetchLogo();
  }, [])




  const fetchLogo = async () => {
    const res = await getCompanyApi()
    if (res && res.data) {
      const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = res.data.favicon;
      document.getElementsByTagName("head")[0].appendChild(link);

      document.title = res.data.panelName;

      setLogo(res.data.logo);
      changeFavicon(res.data.favicon);
      setClentId(res.data.GOOGLE_CLIENT_ID)
    }
  }

  const changeFavicon = (iconPath) => {
    const link = document.querySelector("favicon") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = iconPath;
    document.getElementsByTagName("head")[0].appendChild(link);
  };


  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      UserName: "",
      countryCode: "+91",
      PhoneNo: "",
      Email: "",
      password: "",
      confirmPassword: "",
      ReferredBy: refCode || "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name is required"),
      lastName: Yup.string().required("Last name is required"),
      UserName: Yup.string().required("Username is required"),
      PhoneNo: Yup.string()
        .matches(/^[0-9]+$/, "Phone number is not valid")
        .min(10, "Phone number must be exactly 10 digits")
        .max(10, "Phone number must be exactly 10 digits")
        .required("Phone number is required"),
      Email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
      // ReferredBy: Yup.string().required("Referral code is required"),
    }),
    onSubmit: async (values) => {
      const { confirmPassword, firstName, lastName, countryCode, PhoneNo, ...otherValues } = values;

      // Concatenate firstName and lastName to create FullName
      const FullName = `${firstName.trim()} ${lastName.trim()}`;

      // Concatenate countryCode and PhoneNo
      const fullPhoneNumber = `${countryCode}${PhoneNo}`;

      const dataToSubmit = {
        ...otherValues,
        FullName: FullName,
        PhoneNo: fullPhoneNumber,
        UserName: values.UserName.toLowerCase(),
      };

      try {
        const response = await SignIn(dataToSubmit);

        if (response.status) {
          Swal.fire({
            icon: "success",
            title: "Registration successful",
            text: response.message,
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            navigate("/login");
          })
          // }).then(() => {
          //   window.location.href = `https://${window.location.hostname}/backend/Downloadapk`;
          // });
        } else {
          Swal.fire({
            icon: "error",
            title: "Registration failed",
            text: response.message || "An error occurred. Please try again.",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Registration failed",
          text:
            error.response?.data?.message ||
            "An error occurred. Please try again.",
        });
      }
    },
  });



  const handleGoogleSuccess = async (credentialResponse) => {
    try {

      const id_token = credentialResponse.credential;
      const decoded = jwtDecode(id_token);

      const res = await googleLogin({
        id_token,
        ReferredBy: "",
        withCredentials: true
      });

      if (res.status) {
        localStorage.setItem("token", res.data.token);
        Swal.fire({
          icon: "success",
          title: "Login successful",
          text: "Welcome " + decoded.name,
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = `https://${window.location.hostname}/backend/Downloadapk`;
        });;
      } else {
        Swal.fire({
          icon: "error",
          title: "Google Login Failed",
          text: res.data.message,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Google Login Error",
        text: error.message,
      });
    }
  };


  const handleGoogleError = () => {
    Swal.fire({
      icon: "error",
      title: "Google Login Failed",
      text: "Please try again.",
    });
  };


  return (
    <div className="authincation d-flex flex-column flex-lg-row flex-column-fluid">
      <div className="login-aside text-center d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <div className="text-center mb-lg-4 mb-2 pt-5 logo">
            <img src={logo} style={{ height: "100px" }} alt="Logo" />
          </div>
          <h3 className="mb-2 text-white">Welcome back!</h3>

        </div>

        <div
          className="aside-image position-relative"
          style={{
            backgroundImage: "url(/assets/images/background/pic-2.png)",
          }}
        >
          <img
            className="img1 move-1"
            src="assets/images/background/pic3.png"
            alt=""
          />
          <img
            className="img2 move-2"
            src="assets/images/background/pic4.png"
            alt=""
          />
          <img
            className="img3 move-3"
            src="assets/images/background/pic5.png"
            alt=""
          />
        </div>
      </div>
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="card mb-0 h-auto">
              <div className="card-body">
                <div className="text-center mb-3">

                </div>
                <div className="d-flex justify-content-center">
                  <GoogleOAuthProvider clientId={clientId} >
                    <GoogleLogin onSuccess={handleGoogleSuccess} onError={handleGoogleError} />
                  </GoogleOAuthProvider>
                </div>
                <h2 className="text-center mb-2">Sign Up</h2>
                <form onSubmit={formik.handleSubmit}>

                  {/* First Name and Last Name in one row */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label" htmlFor="firstName">
                        First Name
                      </label>
                      <input
                        id="firstName"
                        type="text"
                        className={`form-control ${formik.touched.firstName && formik.errors.firstName
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("firstName")}
                      />
                      {formik.touched.firstName && formik.errors.firstName ? (
                        <div className="invalid-feedback">
                          {formik.errors.firstName}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-6">
                      <label className="form-label" htmlFor="lastName">
                        Last Name
                      </label>
                      <input
                        id="lastName"
                        type="text"
                        className={`form-control ${formik.touched.lastName && formik.errors.lastName
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("lastName")}
                      />
                      {formik.touched.lastName && formik.errors.lastName ? (
                        <div className="invalid-feedback">
                          {formik.errors.lastName}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="UserName">
                      Username
                    </label>
                    <input
                      id="UserName"
                      type="text"
                      className={`form-control ${formik.touched.UserName && formik.errors.UserName
                        ? "is-invalid"
                        : ""
                        }`}
                      {...formik.getFieldProps("UserName")}
                      onInput={(e) => (e.target.value = e.target.value.toLowerCase())} // Force lowercase input
                    />
                    {formik.touched.UserName && formik.errors.UserName ? (
                      <div className="invalid-feedback">
                        {formik.errors.UserName}
                      </div>
                    ) : null}
                  </div>

                  {/* Country Code and Phone Number in one row */}
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label className="form-label" htmlFor="countryCode">
                        Country Code
                      </label>
                      <select
                        id="countryCode"
                        className={`form-select ${formik.touched.countryCode && formik.errors.countryCode
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("countryCode")}
                      >
                        <option value="">Select Country Code</option>
                        {CountryCodes?.map((country) => (
                          <option key={country.code} value={country.code}>
                            {country.country} ({country.code})
                          </option>
                        ))}
                      </select>

                      {formik.touched.countryCode && formik.errors.countryCode ? (
                        <div className="invalid-feedback">
                          {formik.errors.countryCode}
                        </div>
                      ) : null}
                    </div>

                    <div className="col-md-8">
                      <label className="form-label" htmlFor="PhoneNo">
                        Phone Number
                      </label>
                      <input
                        id="PhoneNo"
                        type="text"
                        maxLength={10}
                        className={`form-control ${formik.touched.PhoneNo && formik.errors.PhoneNo
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("PhoneNo")}
                      />
                      {formik.touched.PhoneNo && formik.errors.PhoneNo ? (
                        <div className="invalid-feedback">
                          {formik.errors.PhoneNo}
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="Email">
                      Email
                    </label>
                    <input
                      id="Email"
                      type="email"
                      className={`form-control ${formik.touched.Email && formik.errors.Email ? "is-invalid" : ""
                        }`}
                      {...formik.getFieldProps("Email")} // Ensure proper binding
                    />
                    {formik.touched.Email && formik.errors.Email ? (
                      <div className="invalid-feedback">{formik.errors.Email}</div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="password">
                      Password
                    </label>
                    <div className="input-group">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        className={`form-control ${formik.touched.password && formik.errors.password
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("password")}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    {formik.touched.password && formik.errors.password ? (
                      <div className="invalid-feedback">
                        {formik.errors.password}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="confirmPassword">
                      Confirm Password
                    </label>
                    <div className="input-group">
                      <input
                        id="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        className={`form-control ${formik.touched.confirmPassword &&
                          formik.errors.confirmPassword
                          ? "is-invalid"
                          : ""
                          }`}
                        {...formik.getFieldProps("confirmPassword")}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }>
                        {showConfirmPassword ? "Hide" : "Show"}
                      </button>
                    </div>
                    {formik.touched.confirmPassword &&
                      formik.errors.confirmPassword ? (
                      <div className="invalid-feedback">
                        {formik.errors.confirmPassword}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <label className="form-label" htmlFor="ReferredBy">
                      Referral Code
                    </label>
                    <input
                      id="ReferredBy"
                      type="text"
                      className={`form-control ${formik.touched.ReferredBy && formik.errors.ReferredBy
                        ? "is-invalid"
                        : ""
                        }`}
                      {...formik.getFieldProps("ReferredBy")}
                    />
                    {formik.touched.ReferredBy && formik.errors.ReferredBy ? (
                      <div className="invalid-feedback">
                        {formik.errors.ReferredBy}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3 d-grid">
                    <button
                      className="btn btn-primary"
                      type="submit"
                    // disabled={!formik.isValid || formik.isSubmitting}>
                    >
                      Register
                    </button>
                  </div>

                  <div className="new-account mt-3 text-center">
                    <p className="font-w500">
                      Already have an account?{" "}
                      <Link className="text-primary" to="/login">
                        Back to Login
                      </Link>
                    </p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;  